import clsx from 'clsx';
import CrossIcon from '@images/svg-icons/crossIcon.svg';
import CrossIconMobile from '@images/svg-icons/closeIconPrescr.svg';
import CrossIconEyewearPrescription from '@images/svg-icons/crossIconHowToReadEyewear.svg';

import  {useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers';

interface Props {
    isOpen: boolean;
    close: () => void;
    children: any;
    showCloseIcon?: boolean;
    isCentered?: boolean;
    customStyle?:
        | 'eye-exams-modal'
        | 'eye-exams-modal-sm'
        | 'payment-methods-sm'
        | 'eye-exams-form-modal-sm'
        | 'delete-prescription-sm'
        | 'pd-modal-sm'
        | 'go-back-modal-sm'
        | 'delete-prescription-desk'
        | 'go-back-modal-desk'
        | '';
    isHowToReadEye?: boolean;
    isPrescriptionInfoOpen?: boolean;
    isDataAvailableCallZero?: boolean;
}

const Modal = ({
    isOpen,
    close,
    children,
    showCloseIcon = true,
    isCentered = true,
    customStyle,
    isHowToReadEye = false,
    isPrescriptionInfoOpen = false,
    isDataAvailableCallZero = false,
}: Props): JSX.Element => {
    const ModalClassNames = clsx(
        'modal-container',
        isCentered && 'modal--centred',
        customStyle === 'eye-exams-modal-sm' && 'modal--eye-exams-modal-sm',
        customStyle === 'eye-exams-form-modal-sm' && 'modal--eye-exams-form-modal-sm',
        customStyle === 'payment-methods-sm' && 'modal--payment-methods-modal-sm',
        customStyle === 'delete-prescription-desk' && 'delete-prescription-desk',
        customStyle === 'go-back-modal-desk' && 'go-back-modal-desk'
    );
    const isMobile = useSelector((state: RootState) => state.common.isMobile);

    return (
        isOpen && (
            <>
                <div className="background-layer" onClick={close}></div>
                <div className={ModalClassNames} {...(isDataAvailableCallZero ? {"data-analytics_available_call": "0"} : '')}>
                    {showCloseIcon && isHowToReadEye && !isMobile && (
                        <button
                            aria-label="Close button"
                            className="icon-container"
                            onClick={close}
                            data-analytics_available_call="0"
                        >
                            {isMobile ? <CrossIconMobile /> : <CrossIconEyewearPrescription />}
                        </button>
                    )}
                    <div className="modal-content">
                        {showCloseIcon && !isHowToReadEye && !isPrescriptionInfoOpen && (
                            <button
                                aria-label="Close button"
                                className="icon-container"
                                onClick={close}
                                data-analytics_available_call="0"
                            >
                                {isMobile ? <CrossIconMobile /> : <CrossIcon />}
                            </button>
                        )}
                        {showCloseIcon && !isHowToReadEye && isPrescriptionInfoOpen && (
                            <button
                                aria-label="Close button"
                                className="icon-container is-prescription-info-open"
                                onClick={close}
                                data-analytics_available_call="0"
                            >
                                {isMobile ? <CrossIconMobile /> : <CrossIcon />}
                            </button>
                        )}
                        {showCloseIcon && isHowToReadEye && isMobile && (
                            <div className="how-to-read-espot-container-eyewear-close-button">
                                <button
                                    aria-label="Close button"
                                    className="icon-container"
                                    onClick={close}
                                    data-analytics_available_call="0"
                                >
                                    {isMobile ? <CrossIconMobile /> : <CrossIcon />}
                                </button>
                            </div>
                        )}
                        {children}
                    </div>
                </div>
            </>
        )
    );
};
export default Modal;
